import 'ui-core/components/tabs/js/tabs';

UX.tab.additionalControl = function () {
    const tabsWrapper = document.querySelectorAll('[role="tablist"]');
    tabsWrapper.forEach(wrapper => {
        const tabLinks = wrapper.querySelectorAll('[role="tab"]'),
            keyDownHandler = e => UX.tab.tabsAccessibilityHandler(tabLinks, e);

        tabLinks.forEach((item, index) => {
            if (item.parentElement.classList.contains('active')) {
                item.tabIndex = 0;
                item.ariaSelected = 'true';
            } else {
                item.tabIndex = -1;
                item.ariaSelected = 'false';
            }
            item.dataset.tab = `${index}`;
            item.addEventListener('keydown', keyDownHandler);

            item.addEventListener('click', () => {
                tabLinks.forEach(tab => {
                    tab.tabIndex = -1;
                    tab.ariaSelected = 'false';
                });
                item.tabIndex = 0;
                item.ariaSelected = 'true';

                const targetPane = document.querySelector(item.dataset.target);
                if (targetPane) {
                    const tabContent = targetPane.closest('.tab__content');
                    if (tabContent) {
                        const allPanes = tabContent.querySelectorAll('.tab__pane');
                        allPanes.forEach(pane => {
                            if (pane === targetPane) {
                                pane.setAttribute('aria-hidden', 'false');
                            } else {
                                pane.setAttribute('aria-hidden', 'true');
                            }
                        });
                    }

                    const childTablist = targetPane.querySelector('[role="tablist"]');
                    if (childTablist) {
                        const childTabs = childTablist.querySelectorAll('[role="tab"]');
                        if (childTabs.length > 0) {
                            childTabs.forEach((childTab, childIndex) => {
                                const targetChildPane = document.querySelector(childTab.dataset.target);

                                if (childIndex === 0) {
                                    childTab.tabIndex = 0;
                                    childTab.ariaSelected = 'true';
                                    targetChildPane?.setAttribute('aria-hidden', 'false');
                                } else {
                                    childTab.tabIndex = -1;
                                    childTab.ariaSelected = 'false';
                                    targetChildPane?.setAttribute('aria-hidden', 'true');
                                }
                            });
                        }
                    }
                }
            });
        });
    });
};

UX.tab.tabsAccessibilityHandler = (tabLinks, e) => {
    const {code} = e;

    const overlayElement = document.querySelector('.acs_ajaxOverlay');

    if ((code === 'ArrowLeft' || code === 'ArrowRight' || code === 'Enter') && !overlayElement) {
        const itemIndex = parseInt(e.target.dataset.tab);
        const currentTab = e.target.closest('.tab__nav').querySelector('[role="tab"][tabindex="0"]');
        currentTab.ariaSelected = 'false';
        currentTab.tabIndex = -1;

        let targetLink;
        if (code === 'Enter') {
            targetLink = tabLinks[itemIndex];
        } else {
            switch (code) {
                case 'ArrowRight':
                    targetLink = tabLinks[itemIndex + 1] || tabLinks[0];
                    break;
                case 'ArrowLeft':
                    targetLink = tabLinks[itemIndex - 1] || tabLinks[tabLinks.length - 1];
                    break;
            }
        }

        targetLink.ariaSelected = 'true';
        targetLink.tabIndex = 0;
        targetLink.click();
        if (code !== 'Enter') {
            targetLink.focus();
        }
    }
};

UX.tab.setPostbackActiveTab = tabID => {
    if (!tabID) return;
    const activeTabs = document.querySelectorAll(`[data-simple-tab-id="${tabID}"]`);
    activeTabs.forEach(tab => tab.click());
};
